exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weui-switch__red:checked{border-color:#e64340;background-color:#e64340}", "", {"version":3,"sources":["/./src/components/forms/switch.vue"],"names":[],"mappings":"AACA,0BAA0B,qBAAqB,wBAAwB,CACtE","file":"switch.vue","sourcesContent":["\n.weui-switch__red:checked{border-color:#E64340;background-color:#E64340\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-76d84fc9!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/switch.vue
// module id = 98
// module chunks = 0